// extracted by mini-css-extract-plugin
export default {"container":"SkillGage_container__l5LnF","skill":"SkillGage_skill__UubD9","popUp":"SkillGage_popUp__nJPV2","skillName":"SkillGage_skillName__ed0ye"};